import { render, staticRenderFns } from "./title-switcher.vue?vue&type=template&id=3aec394d&scoped=true"
import script from "./title-switcher.vue?vue&type=script&lang=js"
export * from "./title-switcher.vue?vue&type=script&lang=js"
import style0 from "./title-switcher.vue?vue&type=style&index=0&id=3aec394d&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/.pnpm/vue-loader@15.11.1_j7fuxwmg3pjjrof4ryv5g7uhre/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3aec394d",
  null
  
)

export default component.exports